// @flow

import type { FeatureAction, FeatureState } from 'stores/flow-type/feature.type';

import {
  CHECK_LIVE_THEME_SUPPORTED_REQUEST,
  CHECK_LIVE_THEME_SUPPORTED_SUCCESS,
  CHECK_LIVE_THEME_SUPPORTED_FAILURE
} from 'stores/flow-type/feature.type';

const initialState: FeatureState = {
  featuresList: {},
  loading: false,
  success: false,
  error: undefined
};

const featureReducers = (state: FeatureState = initialState, action: FeatureAction) => {
  switch (action.type) {
    case CHECK_LIVE_THEME_SUPPORTED_REQUEST:
      return { ...state, loading: true, success: false, featuresList: {} };
    case CHECK_LIVE_THEME_SUPPORTED_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        featuresList: data,
        loading: false,
        success: true,
        error: undefined
      };
    }
    case CHECK_LIVE_THEME_SUPPORTED_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };
    default:
      return state;
  }
};
export default featureReducers;
